export const SERVICEBOSS_ANALYTICS_ID = "G-WDVY0VK7TL";
export const SERVICEBYREG_ANALYTICS_ID = "G-B2X2DMEL2N";
export const SERVICELAD_ANALYTICS_ID = "G-30KMGVWPH4";
export const SERVICEBOSS_CONSENT_KEY = "sb-analytics-consent-v1";
export const SERVICEBYREG_CONSENT_KEY = "sbr-analytics-consent-v1";
export const SERVICELAD_CONSENT_KEY = "sl-analytics-consent-v1";

function consentGatedTagHtml({ analyticsId, consentKey, loadFnName, dataAttr }) {
  return `<!-- Google tag (gtag.js) -->
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = window.gtag || gtag;
    gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
    window.${loadFnName} = window.${loadFnName} || function () {
      if (document.querySelector('script[${dataAttr}]')) return;
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=${analyticsId}';
      script.setAttribute('${dataAttr}', 'true');
      document.head.appendChild(script);
      gtag('js', new Date());
      gtag('config', '${analyticsId}');
    };
    try {
      if (window.localStorage.getItem('${consentKey}') === 'granted') {
        gtag('consent', 'update', { analytics_storage: 'granted' });
        window.${loadFnName}();
      }
    } catch (error) {}
  </script>`;
}

export function googleAnalyticsHeadHtml(siteKey) {
  if (siteKey === "serviceboss") {
    return consentGatedTagHtml({
      analyticsId: SERVICEBOSS_ANALYTICS_ID,
      consentKey: SERVICEBOSS_CONSENT_KEY,
      loadFnName: "sbLoadGoogleAnalytics",
      dataAttr: "data-sb-google-tag",
    });
  }

  if (siteKey === "servicebyreg") {
    return consentGatedTagHtml({
      analyticsId: SERVICEBYREG_ANALYTICS_ID,
      consentKey: SERVICEBYREG_CONSENT_KEY,
      loadFnName: "sbrLoadGoogleAnalytics",
      dataAttr: "data-sbr-google-tag",
    });
  }

  if (siteKey === "servicelad") {
    return consentGatedTagHtml({
      analyticsId: SERVICELAD_ANALYTICS_ID,
      loadFnName: "slLoadGoogleAnalytics",
      consentKey: SERVICELAD_CONSENT_KEY,
      dataAttr: "data-sl-google-tag",
    });
  }

  return "";
}
